import { Stack, SxProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { LockStateEnum } from '~enums';
import { getLockStateEnumLabel } from '~enums/lockStateEnum';
import { BaseReference } from '~interfaces';
import { Dimens } from '~themes';

import Dropdown from './dropdown';

interface LockStateDropdownProps {
	onValueChanged: (newValue?: LockStateEnum) => void;
	disableClearable?: boolean;
	selectedValue?: LockStateEnum;
	label?: string;
	sx?: SxProps;
}

const LockStateDropdown = ({ label, sx, ...props }: LockStateDropdownProps) => {
	const { t } = useTranslation();

	// Data
	const options = [LockStateEnum.Locked, LockStateEnum.Unlocked, LockStateEnum.Unknown].sort().map(
		(option) =>
			({
				id: option as string,
				name: option ? getLockStateEnumLabel(option, t) : t('general.none', { ns: 'entities' }),
			}) as BaseReference
	);

	// Component
	return (
		<Stack sx={{ gap: Dimens.spacingXs }}>
			{label && <Typography variant='labelSm'>{label}</Typography>}
			<Dropdown
				values={options}
				value={
					props.selectedValue ?
						{
							id: props.selectedValue,
							name: getLockStateEnumLabel(props.selectedValue, t),
						}
					:	undefined
				}
				placeholder={t('device.labels.lockState', { ns: 'entities' })}
				sx={sx}
				canClear
				onValueChanged={(newValue) => {
					props.onValueChanged(newValue?.id as LockStateEnum);
				}}
			/>
		</Stack>
	);
};

export default LockStateDropdown;
